<template>
  <div>
    <TabelaCompraDepartamentos
      :height="height_tabela"
      :grupo="grupoCompra"
      :habilitar_exportacao_excel="true"
      :callback-nivel1="buscarDepartamentos"
      :callback-nivel2="buscarSecoesDepartamento"
      :callback-nivel3="buscarCategoriasSecao"
      :callback-nivel4="buscarProdutosCategorria"
    >
      <template #item.sugestao_compra_em_quantidade="{item}">
        <div class="d-flex align-center">
          <span v-text="`${Helpers.formatarValor(item.sugestao_compra_em_quantidade)} ${item.unidade_compra}`" />

          <v-spacer />

          <button v-if="item.nivel_expancao === NIVEIS_DE_EXPANCAO.PRIMEIRO && !item.linha_totalizadora" @click.stop="irParaTelaCompras(item)">
            <v-icon large>$SetaParaDireita</v-icon>
          </button>
        </div>
      </template>
    </TabelaCompraDepartamentos>

    <!--
    <Carrinho />
    -->
  </div>
</template>

<script>
import TabelaCompraDepartamentos from "../../utils/dataTable/sysDataTableDepartamentos/Index.vue";
//import Carrinho from "./carrinho/Index";

import {buscarDepartamentosCompraDashboard} from "../../../api/compraPorDepartamentos/Departamento.js";
import {buscarSecoesCompraPorDepartamento} from "../../../api/compraPorDepartamentos/Secao";
import {buscarCategoriasCompraPorSecao} from "../../../api/compraPorDepartamentos/Categoria.js";
import {buscarProdutosCompraPorCategoria} from "../../../api/compraPorDepartamentos/Produto.js";

import pushTelaComprasPorDepartamentos from "./helpers/PushTelaComprasPorDepartamentos.js";
import Responsividade from "../../../helpers/ResponsiveHeight.js";
import {NIVEIS_DE_EXPANCAO} from "../../utils/dataTable/sysDataTableDepartamentos/NiveisDeExpancao.js";
import {mapGetters} from "vuex";


export default {
  name: "Index",
  mixins: [pushTelaComprasPorDepartamentos, Responsividade],
  components: {
    //Carrinho,
    TabelaCompraDepartamentos
  },
  data: () => ({
    ativar_analise_cotacoes: false,
    NIVEIS_DE_EXPANCAO,
    filtros: {
      compradores: [],
      status: "",
    }
  }),
  computed: {
    ...mapGetters({
      "grupoCompra": "usuario/getGrupoCompras"
    }),
    height_tabela(){
      return parseInt(this.alturaDaJanela - 425);
    }
  },
  created() {
    this.ativar_analise_cotacoes = localStorage.compras_analise_por_departamentos === "true";
  },
  methods: {
    async buscarDepartamentos(filtros) {
      return await buscarDepartamentosCompraDashboard(filtros);
    },
    async buscarSecoesDepartamento({iddepartamento}, filtros) {
      const parametros = {
        iddepartamento,
        ...filtros
      };
      return await buscarSecoesCompraPorDepartamento(parametros);
    },
    async buscarCategoriasSecao({iddepartamento, idsecao}, filtros) {
      const parametros = {
        iddepartamento,
        idsecao,
        ...filtros
      };
      return await buscarCategoriasCompraPorSecao(parametros);
    },
    async buscarProdutosCategorria({iddepartamento, idsecao, idcategoria}, filtros) {
      const parametros = {
        iddepartamento,
        idsecao,
        idcategoria,
        ...filtros
      };
      return await buscarProdutosCompraPorCategoria(parametros);
    },
    irParaTelaCompras(item) {
      const parametros_rota = {
        id_grupo: this.grupoCompra,
        id_departamento: item.iddepartamento
      };
      this.pushTelaComprasPorDepartamentos(parametros_rota);
    }
  }
}
</script>
